import { render, staticRenderFns } from "./home-promo.vue?vue&type=template&id=49255609&scoped=true"
import script from "./home-promo.vue?vue&type=script&lang=js"
export * from "./home-promo.vue?vue&type=script&lang=js"
import style0 from "./home-promo.vue?vue&type=style&index=0&id=49255609&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49255609",
  null
  
)

export default component.exports